import React, { useState } from "react";
import styled from "styled-components";
import _classnames from "classnames";
import { withStyles } from "@mui/styles";
import { Checkbox } from "../base/Input";
import { useEffect } from "react";
import { TreeItem } from "@mui/x-tree-view";
import Icon from "@mui/material/Icon";

const Wrapper = styled.div`
  margin-right: 5px;
  display: flex;
  padding: 4px 0px;
  align-items: center;
`;

const Title = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.43;
  letter-spacing: 0.01071em;
`;

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    "& .tree-close": {
      opacity: 0.3,
    },
  },
  group: {
    marginLeft: 12,
    paddingLeft: 12,
    borderLeft: `1px dashed `,
  },
}))((props) => {
  const { nodeId, ...rest } = props;
  return <TreeItem {...rest} itemId={nodeId ?? rest.itemId} />;
});

export default function CustomTreeView(props) {
  const {
    children,
    nodeId,
    title,
    icon,
    IconComponent, // Prop for MUI icon component (e.g., from @mui/icons-material)
    data,
    renderAfter,
    checkable,
    checked,
    onCheck,
    onSelection,
    disabled,
    classIcon,
  } = props;
  const [check, setCheck] = useState(false);
  useEffect(() => {
    if (checkable) {
      setCheck(checked);
    }
  }, [checkable, checked]);

  // Render icon - support MUI component, MUI Icon string names, and legacy FA classes
  const renderIcon = () => {
    // If IconComponent is provided (MUI icon component), use it directly
    if (IconComponent) {
      return (
        <IconComponent sx={{ fontSize: 16, mr: 1 }} className={classIcon} />
      );
    }

    return (
      <Icon sx={{ fontSize: 18, mr: 1 }} className={classIcon}>
        {data?.icon || ""}
      </Icon>
    );
  };

  return (
    <StyledTreeItem
      nodeId={nodeId}
      label={
        <Wrapper onClick={(e) => onSelection && onSelection(e, data)}>
          {checkable && (
            <Checkbox
              disabled={disabled}
              checked={check}
              color="primary"
              onChange={(e) => {
                let valueChecked = !check;
                setCheck(valueChecked);
                if (onCheck) {
                  onCheck(e, valueChecked, data);
                }
              }}
            />
          )}
          <Wrapper>
            {renderIcon()}
            <Title>{title}</Title>
          </Wrapper>
          {renderAfter}
        </Wrapper>
      }
    >
      {children}
    </StyledTreeItem>
  );
}
